import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'

import NProgress from "nprogress";
import "nprogress/nprogress.css";
import "./plugins/element.js";
import "./assets/css/base.css";

import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";

Vue.prototype.parseTime = parseTime


// 引入cookies
import VueCookies from "vue-cookies";

import FilePreview from './views/FilePreview.vue'

Vue.component('FilePreview', FilePreview)

const whiteList = ['/login', '/register'];// 不重定向白名单

Vue.config.productionTip = false


import download from '@/plugins/download'

import { getToken } from '@/utils/auth'

Vue.prototype.$download = download



//路由守卫
router.beforeEach((to, from, next) => {

  if (getToken()) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      // 获取用户余额（如果还没有获取过）
      if (!store.getters.balance || store.getters.balance === "0.00") {
        store.dispatch("GetBalance").catch(() => {});
      }
      next();
      NProgress.done();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
